<template>
  <md-menu :md-offset-x="-450" :md-offset-y="0" :md-active.sync="toggleMenu">
    <md-button md-menu-trigger class="md-icon-button md-dense md-transparent notification-menu-button">
      <span v-if="notifications.length !== 0" class="notification">{{ notifications.length }}</span>
      <md-icon>notifications</md-icon>
    </md-button>
    <md-menu-content class="md-size-100">
      <div class="notification-row" v-for="notification in notifications" :key="notification.id">
        <div class="md-layout md-alignment-space-between-center">
          <div class="md-layout-item no-padding">
            <div class="notification-level">
              <i
                class="fas fa-fw fa-sm fa-1_5x"
                :class="notificationLevelFontawesome(notification)"
                aria-hidden="true"
              ></i>
            </div>
            <h4 class="no-margin notification-sender">{{ notification.sender | capitalize }}</h4>
          </div>
          <div
            class="md-layout-item md-size-10 text-right vertical-center mark-as-read"
            @click="markNotificationAsRead(notification.id)"
          >
            <i class="fas fa-times-circle fa-fw" aria-hidden="true"></i>
          </div>
        </div>
        <div class="md-layout notification-verb-container">
          <div class="notification-verb-content">
            {{ notification.verb }}
            <span
              v-if="notification.description"
              class="notification-more"
              @click="showNotificationDescription(notification.id)"
              >more...</span
            >
          </div>
          <span class="notification-timestamp">{{ notification.timestamp | formatTime }}</span>
        </div>
      </div>

      <div class="notification-row color-gray" v-if="notifications.length === 0">
        There is no new notifications for you!
      </div>
    </md-menu-content>

    <md-dialog
      :md-active.sync="showNotificationDescriptionModal"
      :md-close-on-esc="false"
      class="warning-dialog"
      @md-clicked-outside="showNotificationDescriptionModal = false"
      @keyup.esc="showNotificationDescriptionModal = false"
    >
      <div class="md-dialog-content md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
          <h3>Notification</h3>

          <!--suppress HtmlUnknownAttribute -->
          <div class="md-subheading warning-text" v-dompurify-html="selectedNotificationForModal.description"></div>
          <div dir="rtl">
            <md-button
              @click="
                markNotificationAsRead(selectedNotificationForModal.id);
                showNotificationDescriptionModal = false;
              "
              class="md-primary"
              >Mark As Read</md-button
            >
            <md-button @click="showNotificationDescriptionModal = false">Close</md-button>
          </div>
        </div>
      </div>
    </md-dialog>
  </md-menu>
</template>

<script>
import { ref, onUnmounted } from "@vue/composition-api";
import apiManager from "../api-manager";
import moment from "moment";

export default {
  name: "TopBarNotifications",

  setup: (props, { emit }) => {
    let notificationTimerId = null;
    const notifications = ref([]);
    const selectedNotificationForModal = ref({
      id: -1,
      description: "",
    });
    const showNotificationDescriptionModal = ref(false);
    const fetchNotifications = async () => {
      const response = await apiManager.getNotifications();
      if (response.status === 200) {
        notifications.value = response.parsedData.notifications;
      }
    };
    const markNotificationAsRead = async (notificationPK) => {
      const response = await apiManager.markNotificationAsRead({ params: { notification_pk: notificationPK } });
      if (response.status === 200) {
        await fetchNotifications();
      }
    };
    const notificationLevelFontawesome = (notification) => {
      switch (notification.level) {
        case "info":
          return "fa-info-circle";
        case "warning":
          return "fa-exclamation-triangle";
        case "success":
          return "fa-check-circle";
        case "error":
          return "fa-exclamation-circle";
      }
    };
    const showNotificationDescription = (notificationId) => {
      selectedNotificationForModal.value = notifications.value.filter((item) => {
        return item.id === notificationId;
      })[0];

      showNotificationDescriptionModal.value = true;
      toggleMenu.value = false;
    };

    const toggleMenu = ref(false);

    // Fetch notifications on start
    fetchNotifications();
    notificationTimerId = setInterval(() => {
      fetchNotifications();
    }, 60000);

    onUnmounted(() => {
      if (notificationTimerId) {
        clearInterval(notificationTimerId);
        notificationTimerId = null;
      }
    });

    return {
      notifications,
      fetchNotifications,
      markNotificationAsRead,
      notificationLevelFontawesome,
      showNotificationDescription,
      selectedNotificationForModal,
      showNotificationDescriptionModal,
      toggleMenu,
    };
  },

  filters: {
    formatTime(value) {
      if (!value) return "";
      return moment(value).format("MMMM Do YYYY, h:mm:ss A"); // April 3rd 2021, 5:23:32 AM
    },
  },
};
</script>

<style lang="scss" scoped>
.md-menu-content {
  min-width: 30%;
}

.notification-row {
  padding: 8px 15px;
}

.no-margin {
  margin: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

.color-gray {
  color: gray;
}

.notification-timestamp {
  color: gray;
  font-size: smaller;
  margin-left: auto;
}

.notification-verb-content {
  display: inline-block;
  white-space: initial;
  text-align: justify;
  width: 100%;
}

.vertical-center {
  vertical-align: middle;
  margin-top: auto;
}

.fa-1_5x {
  font-size: 1.5em !important;
}

.notification-level {
  padding-right: 4px;
  text-align: left;

  .fa-exclamation-circle {
    color: #ef5350;
  }

  .fa-check-circle {
    color: #66bb6a;
  }

  .fa-info-circle {
    color: #26c6da;
  }

  .fa-exclamation-triangle {
    color: #ffa726;
  }
}

.notification-level,
.notification-sender {
  display: inline;
}

.mark-as-read {
  padding-right: 0;
  color: darkgray;
  cursor: pointer;

  :hover {
    color: gray;
  }
}

.notification-more {
  font-size: smaller;
  padding: 0 2px;
  cursor: pointer;
  color: var(--md-theme-default-primary-on-background, #9c27b0);
}

.notification-menu-button {
  overflow: visible;
}
</style>
